
import { Vue, Component, Prop } from 'vue-property-decorator';

export type PanelMode = 'shipTo' | 'soldTo';

@Component
export default class ShipToDropdown extends Vue {
  @Prop({ required: true }) value!: PanelMode;

  private isOpen = false;

  get options() {
    return [
      { value: 'shipTo' as PanelMode, label: this.$t('shipment.shipTo') },
      { value: 'soldTo' as PanelMode, label: this.$t('shipment.soldTo') },
    ];
  }

  get currentLabel(): string {
    const option = this.options.find((o) => o.value === this.value);
    return option ? (option.label as string) : '';
  }

  private select(val: PanelMode): void {
    this.$emit('input', val);
    this.isOpen = false;
  }
}
